import React from 'react'
import { BsInstagram } from "react-icons/bs";
import { Link } from 'react-router-dom';



function Footer() {


  return (

    <div>

      <div id='ff' class="fluid ">
        <footer class="py-3 my-4">
          <ul class="nav justify-content-center border-bottom pb-3 mb-3">
            <li class="nav-item"><Link to="/" id='i' class="nav-link px-2 ">Home</Link></li>
            <li class="nav-item"><Link to="#" id='i' class="nav-link px-2 ">Post</Link></li>
            <li class="nav-item"><Link to="#" id='i' class="nav-link px-2 ">Create_Post</Link></li>
            <li class="nav-item"><Link to="/about" id='i' class="nav-link px-2 ">About</Link></li>
          </ul>

          <p id='foo' class="text-center ">© 2022 Company, Rahul_Chaudhary Inc  <Link to="https://www.instagram.com/rahulchaudhary301/" id='in' ><BsInstagram /></Link>  </p>




        </footer>




      </div>



    </div>
  )
}

export default Footer
